import { ValueType } from '@convergence/types';
import { AnalysisRootValue } from './analysis-root-value';
import { z } from 'zod';

const PropsSchema = z.object({
  values: z.record(
    z.coerce.number(),
    z.object({
      value: z.any(),
      name: z.string()
    })
  )
});

export type AnalysisValueProps = {
  values: Record<number, { value: ValueType; name: string }>;
};

// function getValuesMap(inputs: AnalysisValueProps["inputs"]) {
//     return inputs.reduce((acc, cur) => {
//         return {
//             ...acc,
//             [cur.id]: {
//                 schema: cur.valueSchema.schema,
//                 name: cur.name,
//             }
//         }
//     }, {} as AnalysisValuesMap)
// }
//
export function AnalysisValues(props: AnalysisValueProps) {
  // const [values, setValues] = useState<AnalysisValuesMap>(props.inputs)

  // useEffect(() => {
  //     setValues((prev) => {
  //         const map = getValuesMap(props.inputs)
  //         // we don't want to overwrite values if the type hasn't changed
  //         if (Object.keys(map).sort().join(",") !== Object.keys(prev).sort().join(",")) {
  //             return map
  //         }
  //         return prev
  //     })
  // }, [props.inputs])

  const validProps = PropsSchema.safeParse(props);

  if (!validProps.success) {
    return (
      <div className="text-red-500">
        Invalid props to AnalysisValues:{' '}
        {JSON.stringify(validProps.error.format(), null, 2)}
      </div>
    );
  }

  return (
    <div>
      {Object.entries(props.values).map(([id, { value, name }]) => (
        <AnalysisRootValue
          analysisSchemaId={+id}
          key={`analysis-input-${id}-${name}`}
          value={value}
          name={name}
        />
      ))}
    </div>
  );
}
